module.exports = __webpack_public_path__ + "static/media/landing-page.f960a4d7.jpg";